import { Record } from 'immutable';

const MatchingPropertyAssignRecord = Record({
  'matchingPropertyId': null,
  'vendorSource': null,
  'vendorId': null,
  'chain': null,
  'brand': null,
  'pid': null,
  'name': null
});

export class MatchingPropertyAssign extends MatchingPropertyAssignRecord {
  matchingPropertyId: number;
  vendorSource: string;
  vendorId: string;
  chain: string;
  brand: string;
  pid: string;
  name: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/matching-property-assign.ts